/*--------------------------------------------------------------
# JS Bootstrap Dropdown
--------------------------------------------------------------*/

import * as bootstrap from 'bootstrap';

const selectElements = document.querySelectorAll(".choices-field");

if (selectElements.length > 0) {
    selectElements.forEach((selectElement) => {
        // Skip elements that are handled by Vue
        if (selectElement._dropdown) {
            return;
        }

        const placeholderText = selectElement.dataset.placeholder || "Sélectionner une option";
        const blockTitle = selectElement.dataset.title || null;
        const blockSubtitle = selectElement.dataset.subtitle || null;
        const hiddenColumns = selectElement.dataset.hiddenColumns || false;
        const hiddenImage = selectElement.dataset.hiddenImage || false;
        const classes = selectElement.dataset.classes 
        ? selectElement.dataset.classes.split(',').map(cls => cls.trim())
        : [];

        // Créer un wrapper pour le dropdown
        const wrapper = document.createElement('div');
        wrapper.className = 'dropdown bootstrap-select';
        wrapper.style.width = '100%';

        // Créer le bouton dropdown
        const button = document.createElement('button');
        button.className = 'btn dropdown-toggle';
        button.setAttribute('type', 'button');
        button.setAttribute('data-bs-toggle', 'dropdown');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = `<span class="filter-option">${placeholderText}</span>`;

        // Créer le menu dropdown
        const dropdownMenu = document.createElement('div');
        dropdownMenu.className = 'dropdown-menu w-100 text-start';

        // Ajouter le titre et sous-titre si présents
        if (blockTitle || blockSubtitle) {
            const headerDiv = document.createElement('div');
            headerDiv.className = 'col-md-12 mt-0';
            headerDiv.innerHTML = `
                <p class="h4 text-black my-1">${blockTitle || "Titre par défaut"}</p>
                <p class="text-gray-60 m-0">${blockSubtitle || ""}</p>
            `;
            dropdownMenu.appendChild(headerDiv);
        }

        // Créer la liste des options
        const optionsContainer = document.createElement('div');
        optionsContainer.className = `row g-0 g-md-3 ${classes.join(' ')}`;

        const options = Array.from(selectElement.options).map(option => ({
            value: option.value,
            label: option.text,
            customProperties: {
                sublabel: option.dataset.sublabel || "",
                image: option.dataset.image || "",
                discount: option.dataset.discount || "",
                originalPrice: option.dataset.originalPrice || "",
                price: option.dataset.price || "",
                round: option.dataset.round || "",
            },
        }));

        // Créer les éléments d'option
        options.forEach((option) => {
            if (option.value === '') {
                return; // Skip placeholder option
            }

            const optionDiv = document.createElement('div');
            const columnClass = hiddenColumns 
                ? "col-md-12"
                : "col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4";
            optionDiv.className = columnClass;
            optionDiv.setAttribute('data-value', option.value);

            const isSelected = selectElement.value === option.value;

            const formCheckClass = hiddenImage 
                ? "justify-content-center"
                : "justify-content-end";

            const textColumnClass = hiddenImage 
                ? "col-11 col-md-12 col-lg-12 col-xl-11"
                : "col-6 col-md-7 col-lg-7 col-xl-6";

            let imageHtml = '';
            if (!hiddenImage) {
                imageHtml = `
                    <div class="col-5">
                        ${option.customProperties.discount ? `<div class="badge bg-danger text-white text-center fw-bolder">${option.customProperties.discount}</div>` : ''}
                        ${option.customProperties.image ? `<img src="${option.customProperties.image}" class="card-img" alt="${option.label}">` : ''}
                    </div>
                `;
            }

            let discountBadge = '';
            if (hiddenImage && option.customProperties.discount) {
                discountBadge = `<div class="position-relative me-2 badge bg-danger text-white text-center fw-bolder">${option.customProperties.discount}</div>`;
            }

            optionDiv.innerHTML = `
                <div class="card card-product h-100 is-small ${isSelected ? 'is-selected' : ''}">
                    <div class="row g-0 d-flex align-items-center">
                        <div class="col-1 d-flex d-md-none d-lg-none d-xl-flex ${formCheckClass}">
                            <div class="form-check d-flex align-items-center m-0 h-100">
                                <input class="form-check-input m-0" type="radio" ${isSelected ? 'checked="checked"' : ''}>
                            </div>
                        </div>
                        ${imageHtml}
                        <div class="${textColumnClass}">
                            <div class="card-content">
                                <div class="card-title">
                                    <p class="h6 fw-bolder text-black text-uppercase">${option.label}</p>
                                </div>
                                <div class="card-price">
                                    ${option.customProperties.sublabel ? `<p class="small fw-normal m-0">${option.customProperties.sublabel}</p>` : ''}
                                    <div class="price d-flex flex-row align-items-center pt-2">
                                        ${discountBadge}
                                        ${option.customProperties.originalPrice ? `<span class="old-price fw-normal text-decoration-line-through small fs-xxl-6 me-2">${option.customProperties.originalPrice}€</span>` : ''}
                                        ${option.customProperties.price ? `<span class="price fw-bolder text-info small fs-xl-6 fs-xxl-5 p-lg-0 p-xl-0">${option.customProperties.price}€</span>` : ''}
                                        ${option.customProperties.round ? `<span class="nb fw-normal small">/${option.customProperties.round} tours</span>` : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            // Ajouter un gestionnaire d'événements pour la sélection
            optionDiv.addEventListener('click', () => {
                // Mettre à jour la valeur du select
                selectElement.value = option.value;

                // Déclencher l'événement change
                const event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);

                // Mettre à jour le texte du bouton
                button.querySelector('.filter-option').textContent = option.label;

                // Mettre à jour la classe selected
                optionsContainer.querySelectorAll('.card').forEach(card => {
                    card.classList.remove('is-selected');
                });
                optionDiv.querySelector('.card').classList.add('is-selected');

                // Mettre à jour les radios
                optionsContainer.querySelectorAll('.form-check-input').forEach(input => {
                    input.checked = false;
                });
                optionDiv.querySelector('.form-check-input').checked = true;
            });

            optionsContainer.appendChild(optionDiv);
        });

        dropdownMenu.appendChild(optionsContainer);

        // Cacher le select original
        selectElement.style.display = 'none';

        // Ajouter les éléments au DOM
        wrapper.appendChild(button);
        wrapper.appendChild(dropdownMenu);
        selectElement.parentNode.insertBefore(wrapper, selectElement.nextSibling);

        // Initialiser le dropdown Bootstrap
        const dropdown = new bootstrap.Dropdown(button);

        // Stocker une référence au wrapper pour le nettoyage
        selectElement._dropdown = dropdown;
        selectElement._dropdownWrapper = wrapper;
    });
}
